import React from 'react';
import { useIntl } from 'react-intl-next';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { externalMediaMessages } from '../media';
var baseStyles = xcss({
  borderRadius: 'border.radius',
  backgroundColor: 'elevation.surface',
  lineHeight: "var(--ds-space-200, 16px)",
  cursor: 'pointer'
});
export var ExternalImageBadge = function ExternalImageBadge(_ref) {
  var badgeSize = _ref.badgeSize;
  var intl = useIntl();
  var message = intl.formatMessage(externalMediaMessages.externalMediaFile);
  return /*#__PURE__*/React.createElement(Box, {
    padding: badgeSize === 'medium' ? 'space.050' : 'space.0',
    xcss: baseStyles,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: message,
    position: "top"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    size: "small",
    label: message
  })));
};